/**
 * 撤稿管理完成弹窗
 * Bai.Zhiming
 * 2019-7-2
 */
angular.module("withdrawalMgtDetailModule", []).
controller("withdrawalMgtDetailCtrl", ["info", "$scope", "$modalInstance", function(info, $scope, $modalInstance) {
    $scope.info = info;
    $scope.startEndTimeArray = [];
    if ($scope.info.STARTTIME) {
        $scope.startEndTimeArray.push($scope.info.STARTTIME);
    }
    if ($scope.info.ENDTIME) {
        $scope.startEndTimeArray.push($scope.info.ENDTIME);
    }
    $scope.startEndTime = $scope.startEndTimeArray.join("~");
    /**
     * [close description] 关闭
     * @return {[type]} [description]
     */
    $scope.close = function() {
        $modalInstance.dismiss();
    }
    /**
     * [finish description] 完成
     * @return {[type]} [description]
     */
    $scope.finish = function() {
        $modalInstance.close();
    }
}]);